import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=034fafe7&scoped=true&"
import script from "./AuthLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=034fafe7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034fafe7",
  null
  
)

export default component.exports